export interface Account {
  name: string;
  role: string;
  /** The workspace whose data the shell is showing. */
  workspace: string;
  /** Quoted in support reports so a ticket identifies who hit the failure. */
  email: string;
}

/**
 * Fixture identity for explicit demo mode and isolated component previews.
 * Authenticated UI reads the real identity through useAuth().
 */
export const DEMO_ACCOUNT: Account = {
  name: 'Austin',
  role: 'Administrator',
  workspace: 'Abbott',
  email: 'austin@abbott.com'
};

/** Two-letter monogram for the avatar fallback. */
export const getAccountInitials = ({ name }: Account): string =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('') || '?';
